import { render, staticRenderFns } from "./passo5.vue?vue&type=template&id=0276e4ee&scoped=true&"
import script from "./passo5.vue?vue&type=script&lang=js&"
export * from "./passo5.vue?vue&type=script&lang=js&"
import style0 from "./passo5.vue?vue&type=style&index=0&id=0276e4ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276e4ee",
  null
  
)

export default component.exports